export default __webpack_public_path__ + "static/toolbar-95358a78b10b7f9bb9dd797472c10ade.jpg";